export const DivisionBundle = [
  { label: '沖縄以外', value: '1' },
  { label: '沖縄', value: '2' },
  { label: '直営店掛', value: '3' },
  { label: '本社', value: '4' },
  { label: 'その他', value: '5' },
];
